// extracted by mini-css-extract-plugin
export default {"dialog":"XIMuSftJY6MJ1EV","small":"OzaJoGooIxvTdKs","medium":"k8thm9Bp7wXcLkw","large":"ygJxictASbyA5Wh","close-button":"iGE9Ae1j3jLGYWu"};